export default __webpack_public_path__ + "static/media/mute-short-icon.556e9c99.svg";